function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), React.createElement("path", {
  d: "M208 261L382 87c15-15 15-40 0-55s-39-14-54 0L130 231c-9 8-12 19-11 30-1 11 2 22 11 30l198 198c15 15 39 16 54 0 15-15 15-39 0-54z"
})));